(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.RematchSelect = {})));
}(this, (function (exports) { 'use strict';

	var select = {};
	function getSelect() {
	    return select;
	}
	var selectPlugin = function (_a) {
	    var _b = (_a === void 0 ? {} : _a).sliceState, sliceState = _b === void 0 ? function (rootState, model) { return rootState[model.name]; } : _b;
	    return ({
	        exposed: { select: select },
	        onInit: function () {
	            this.validate([
	                [
	                    typeof sliceState !== 'function',
	                    "The selectPlugin's getState config must be a function. Instead got type " + typeof sliceState + ".",
	                ],
	            ]);
	        },
	        onModel: function (model) {
	            var _this = this;
	            select[model.name] = {};
	            Object.keys(model.selectors || {}).forEach(function (selectorName) {
	                _this.validate([
	                    [
	                        typeof model.selectors[selectorName] !== 'function',
	                        "Selector (" + model.name + "/" + selectorName + ") must be a function",
	                    ],
	                ]);
	                select[model.name][selectorName] = function (state) {
	                    var _a;
	                    var args = [];
	                    for (var _i = 1; _i < arguments.length; _i++) {
	                        args[_i - 1] = arguments[_i];
	                    }
	                    return (_a = model.selectors)[selectorName].apply(_a, [sliceState(state, model)].concat(args));
	                };
	            });
	        },
	    });
	};

	exports.select = select;
	exports.getSelect = getSelect;
	exports.default = selectPlugin;

	Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=rematch-select.umd.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@rematch/select/dist/rematch-select.umd.js
// module id = 933
// module chunks = 0